function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import TrieSearch from 'trie-search';
import { DropdownItem, DropdownMenu, NoResultItem, StyleDropdownMenu } from './style';

class Dropdown extends React.Component {
  getDropdownItemDisplay(item) {
    if (typeof item === 'object') {
      return item.display;
    } else {
      return item;
    }
  }

  getDropdownItemValue(item) {
    if (typeof item === 'object') {
      return item.value;
    } else {
      return item;
    }
  }

  constructor(props) {
    super(props);

    _defineProperty(this, "state", {
      isOpen: false,
      display: ''
    });

    _defineProperty(this, "trie", void 0);

    _defineProperty(this, "ref", /*#__PURE__*/React.createRef());

    _defineProperty(this, "dropdownItemsRefCollection", {});

    _defineProperty(this, "currentlyFocusedDropdownItemIndex", -1);

    _defineProperty(this, "childRef", /*#__PURE__*/React.createRef());

    _defineProperty(this, "firedFromCloseButton", void 0);

    _defineProperty(this, "handleDocumentClick", e => {
      this.firedFromCloseButton = !!(this.props.closeButtonElement && this.props.closeButtonElement.contains(e.target));

      if (this.firedFromCloseButton) {
        return;
      } else if (this.ref && this.ref.current && this.ref.current.contains(e.target)) {
        // stay open
        this.ref.current.focus();
        return;
      }

      this.closeDropdown();
    });

    _defineProperty(this, "handleDropdownItemClick", change => {
      if (change) {
        this.props.onChange(change);
      }

      this.closeDropdown();
    });

    _defineProperty(this, "setDisplayInTypeahead", e => {
      if (!this.props.isTypeahead) {
        return;
      }

      this.setState({
        display: e.target.value
      });
    });

    _defineProperty(this, "handleChildrenClick", () => {
      if (this.firedFromCloseButton) {
        if (this.state.isOpen) {
          this.closeDropdown();
        } else {
          this.openDropdown();
        }

        this.firedFromCloseButton = false;
      } else {
        this.openDropdown();
      }
    });

    _defineProperty(this, "handleChildrenFocus", () => {
      this.openDropdown();
    });

    _defineProperty(this, "renderChildren", isOpen => {
      var child = React.Children.only(this.props.children);
      return /*#__PURE__*/React.createElement("div", {
        onClick: this.handleChildrenClick,
        onChange: this.setDisplayInTypeahead,
        onFocus: this.handleChildrenFocus,
        role: 'presentation',
        "data-test-id": "".concat(this.props.name, "-presentation")
      }, /*#__PURE__*/React.cloneElement(child, {
        disableErrorMessage: isOpen,
        forwardRef: this.childRef
      }));
    });

    _defineProperty(this, "getMatches", () => {
      var results = this.trie.get(this.state.display);
      var numberOfItemsToRender = this.props.numberOfItemsToRender;

      if (!this.state.isOpen) {
        return [];
      }

      var limitedSetOfResults = numberOfItemsToRender ? results.slice(0, numberOfItemsToRender) : results;
      return limitedSetOfResults.map((option, index) => /*#__PURE__*/React.createElement(DropdownItem, {
        key: index,
        tabIndex: -1,
        ref: instance => this.dropdownItemsRefCollection[index] = instance,
        onKeyDown: event => this.handleDropdownItemKeyDown(event, option),
        onClick: () => this.handleDropdownItemClick({
          name: this.props.name,
          value: this.getDropdownItemValue(option)
        })
      }, this.getDropdownItemDisplay(option)));
    });

    _defineProperty(this, "renderDropDownItemWithNoResults", () => /*#__PURE__*/React.createElement(DropdownMenu, {
      wrapsTextInput: this.props.wrapsTextInput
    }, /*#__PURE__*/React.createElement(DropdownItem, null, /*#__PURE__*/React.createElement(NoResultItem, null, " NO RESULTS "))));

    _defineProperty(this, "renderDropdownItems", () => /*#__PURE__*/React.createElement(DropdownMenu, {
      numberOfItemsToBeShown: this.props.numberOfItemsToBeShown,
      wrapsTextInput: this.props.wrapsTextInput
    }, this.props.itemList.map((item, i) => /*#__PURE__*/React.createElement(DropdownItem, {
      key: i,
      tabIndex: -1,
      "data-test-id": "".concat(this.props.name, "-dropdown-").concat(i),
      ref: instance => this.dropdownItemsRefCollection[i] = instance,
      onKeyDown: event => this.handleDropdownItemKeyDown(event, item),
      onClick: () => this.handleDropdownItemClick({
        name: this.props.name,
        value: this.getDropdownItemValue(item)
      })
    }, this.getDropdownItemDisplay(item)))));

    _defineProperty(this, "renderDropdownItemsWithMatchedResults", matchedList => matchedList && /*#__PURE__*/React.createElement(DropdownMenu, {
      numberOfItemsToBeShown: this.props.numberOfItemsToBeShown,
      wrapsTextInput: this.props.wrapsTextInput
    }, matchedList));

    _defineProperty(this, "renderDropdown", () => {
      if (this.props.isTypeahead) {
        var matchedList = this.getMatches();

        if (matchedList.length === 0 && this.state.display !== '' && !this.state.isOpen) {
          return this.renderDropDownItemWithNoResults();
        } else if (matchedList.length === 0) {
          return null;
        }

        return this.renderDropdownItemsWithMatchedResults(matchedList);
      }

      return this.renderDropdownItems();
    });

    _defineProperty(this, "handleDropdownItemKeyDown", (event, dropdownItem) => {
      // Handle enter key
      if (event.keyCode === 13) {
        this.handleDropdownItemClick({
          name: this.props.name,
          value: this.getDropdownItemValue(dropdownItem)
        });
      }
    });

    _defineProperty(this, "handleDropdownAndChildrenKeyDown", event => {
      var numberOfDropdownItems = Object.keys(this.dropdownItemsRefCollection).length;

      if (event.keyCode === 27 || event.keyCode === 9) {
        // Handle esc key or tab key
        this.closeDropdown();
      } else if (event.keyCode === 40) {
        // Handle down arrow key
        if (this.currentlyFocusedDropdownItemIndex < numberOfDropdownItems - 1) {
          event.preventDefault();
          this.currentlyFocusedDropdownItemIndex++;
          this.dropdownItemsRefCollection[this.currentlyFocusedDropdownItemIndex].focus();
        } else if (this.childRef.current) {
          this.currentlyFocusedDropdownItemIndex = -1;
          this.childRef.current.focus();
        }
      } else if (event.keyCode === 38) {
        // Handle up arrow key
        if (this.currentlyFocusedDropdownItemIndex > 0) {
          event.preventDefault();
          this.currentlyFocusedDropdownItemIndex--;
          this.dropdownItemsRefCollection[this.currentlyFocusedDropdownItemIndex].focus();
        } else if (this.childRef.current) {
          if (this.currentlyFocusedDropdownItemIndex === -1) {
            this.currentlyFocusedDropdownItemIndex = numberOfDropdownItems - 1;
            this.dropdownItemsRefCollection[this.currentlyFocusedDropdownItemIndex].focus();
          } else {
            this.currentlyFocusedDropdownItemIndex = -1;
            this.childRef.current.focus();
          }
        }
      }
    });

    this.populateTreeWithItems();
    this.firedFromCloseButton = false;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.itemList !== this.props.itemList) {
      this.populateTreeWithItems();
    } // When the close button is clicked on the typeahead component, we set state isOpen to false


    if (prevProps.numberOfItemsToRender !== this.props.numberOfItemsToRender && this.props.numberOfItemsToRender === 0) {
      this.setState({
        isOpen: false
      });
    }
  }

  populateTreeWithItems() {
    if (this.props.isTypeahead) {
      var transformedItemList = this.props.itemList.map(item => ({
        display: this.getDropdownItemDisplay(item),
        value: this.getDropdownItemValue(item)
      }));
      this.trie = new TrieSearch('display');
      this.trie.addAll(transformedItemList);
    }
  }

  openDropdown() {
    if (!this.state.isOpen) {
      var {
        onInputClick
      } = this.props;
      onInputClick && onInputClick();
      this.setState({
        isOpen: true
      });
      document.addEventListener('mousedown', this.handleDocumentClick);
    }
  }

  closeDropdown() {
    if (this.state.isOpen) {
      var {
        onDropdownClick
      } = this.props;
      onDropdownClick && onDropdownClick();
      this.setState({
        isOpen: false
      });
      this.currentlyFocusedDropdownItemIndex = -1;
      document.removeEventListener('mousedown', this.handleDocumentClick);
    }
  }

  componentWillUnmount() {
    // Remove it again in case the component has been cleared during
    // the dropdown open state.
    document.removeEventListener('mousedown', this.handleDocumentClick);
  }

  render() {
    return /*#__PURE__*/React.createElement(StyleDropdownMenu, {
      ref: this.ref,
      onKeyDown: this.handleDropdownAndChildrenKeyDown
    }, this.renderChildren(this.state.isOpen), this.state.isOpen && this.renderDropdown());
  }

}

export default Dropdown;